<div class="pie-card">
  <div class="pie-header">
    <div>
      <span class="chart-eyebrow">Financeiro</span>
      <h2 class="chart-title">Indicadores de Hoje</h2>
      <p class="chart-subtitle">Orçamentos, vendas e contas do dia atual</p>
    </div>
    <button class="btn btn-outline-secondary btn-sm" type="button" (click)="load()" [disabled]="isLoading()">
      Atualizar
    </button>
  </div>

  @if (isLoading()) {
    <div class="state-box">
      <div class="spinner-border text-primary" role="status"></div>
      <span>Carregando indicadores...</span>
    </div>
  } @else if (hasError()) {
    <div class="state-box error">
      <span>Não foi possível carregar os indicadores de hoje.</span>
      <button class="btn btn-primary btn-sm" type="button" (click)="load()">Tentar novamente</button>
    </div>
  } @else if (indicadores()) {
    <div class="row g-4">
      <div class="col-12 col-lg-6">
        <app-combined-indicator-card
          [title]="'Orçamentos'" [period]="'Hoje'"
          [volume]="indicadores()!.orcamentos.volume"
          [valor]="indicadores()!.orcamentos.valor"
          [color]="'primary'" [icon]="'bi-file-earmark-text'">
        </app-combined-indicator-card>
      </div>
      <div class="col-12 col-lg-6">
        <app-combined-indicator-card
          [title]="'Vendas'" [period]="'Hoje'"
          [volume]="indicadores()!.vendas.volume"
          [valor]="indicadores()!.vendas.valor"
          [color]="'success'" [icon]="'bi-cart-check'">
        </app-combined-indicator-card>
      </div>
      <div class="col-12 col-lg-6">
        <app-combined-indicator-card
          [title]="'Contas Pagas'" [period]="'Hoje'"
          [volume]="indicadores()!.contasPagas.volume"
          [valor]="indicadores()!.contasPagas.valor"
          [color]="'info'" [icon]="'bi-check-circle'">
        </app-combined-indicator-card>
      </div>
      <div class="col-12 col-lg-6">
        <app-combined-indicator-card
          [title]="'Contas a Pagar'" [period]="'Hoje'"
          [volume]="indicadores()!.contasPendentes.volume"
          [valor]="indicadores()!.contasPendentes.valor"
          [color]="'danger'" [icon]="'bi-exclamation-octagon'">
        </app-combined-indicator-card>
      </div>
    </div>
  }
</div>
